import { defineRouting } from 'next-intl/routing';

export const DEFAULT_LOCALES = ['en', 'es', 'fr', 'de', 'it'] as const;
export type SupportedLocale = (typeof DEFAULT_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export const createI18nRouting = (
  locales: readonly string[] = DEFAULT_LOCALES,
  defaultLocale: string = DEFAULT_LOCALE
) => {
  return defineRouting({
    locales: locales as string[],
    defaultLocale,
  });
};

export type Routing = ReturnType<typeof createI18nRouting>;
